import {
  CHATROOM_MESSAGE_FIELD_NAME_TYPE,
  CHATROOM_TYPE,
} from '../../Chatroom.constants'

export const CHATROOM_MESSAGE_TYPE_MODAL_INITIAL_VALUES = {
  [CHATROOM_MESSAGE_FIELD_NAME_TYPE]: CHATROOM_TYPE.Private,
}
